<script setup>
import { ref } from 'vue';
import Sidebar from './Sidebar.vue';
import Topbar from './Topbar.vue';

import { Icon ,Alert} from '@components';

import { isLg, isXl } from '@utils/mediaQuery';

import { useChatCustomizer } from '@store/chatCustomizer';
const $chatCustomizer = useChatCustomizer();


</script>

<template>
<div class="min-h-screen">
    <Alert class="fixed top-3 right-5" />
    <div class="sticky top-0 z-[1]">
        <!-- topbar -->
        <Topbar />

        <!-- sidebar -->
        <Sidebar>
            <div class="flex w-full">
                <div class="w-[76px] bg-[#101828]">
                    <div v-for="(item, index) in $chatCustomizer.primarySidebarMenu" :key="item" class="group" :class="{ 'mt-[-23px]': index > 0 }">
                        <div class="relative w-full h-[23px] z-[4]" :class="{ 'opacity-0': !($chatCustomizer.selectedPrimaryMenu === item.id || $el.matches(':hover')), 'opacity-100': $chatCustomizer.selectedPrimaryMenu === item.id || $el.matches(':hover') }">
                            <div class="absolute inset-0 z-[1] h-full bg-white"></div>
                            <div class="absolute inset-0 z-[2] h-full bg-[#101828] rounded-br-[10px] overflow-hidden"></div>
                        </div>
                        <div class="cursor-pointer flex flex-col items-center gap-1 ml-1 transition-all duration-300 font-medium text-xs py-[20px] px-[10px] rounded-l-[7px]" :class="{
                            'text-white': !($chatCustomizer.selectedPrimaryMenu === item.id || $el.matches(':hover')),
                            'text-[#101828] bg-white': $chatCustomizer.selectedPrimaryMenu === item.id || $el.matches(':hover')
                        }" @click="$chatCustomizer.selectedPrimaryMenu = item.id">
                            <Icon :name="item.icon" size="24px" />
                            {{ item.name }}
                        </div>
                        <div class="relative w-full h-[23px] z-[4]" :class="{ 'opacity-0': !($chatCustomizer.selectedPrimaryMenu === item.id || $el.matches(':hover')), 'opacity-100': $chatCustomizer.selectedPrimaryMenu === item.id || $el.matches(':hover') }">
                            <div class="absolute inset-0 z-[1] h-full bg-white"></div>
                            <div class="absolute inset-0 z-[2] h-full bg-[#101828] rounded-tr-[10px] overflow-hidden"></div>
                        </div>
                    </div>
                </div>
                <div class="w-[calc(100%-76px)]">
                    <div class="h-full w-full px-[53px] py-[30px]">
                        <template v-for="group in $chatCustomizer.secondarySidebarMenu" :key="group.id">
                            <div class="text-[#98A2B3] font-medium text-sm mb-[17px]" :class="{ 'mt-[28px]': group.id !== $chatCustomizer.secondarySidebarMenu[0].id }">
                                {{ group.name }}
                            </div>
                            <div class="flex flex-col items-center gap-[14px]">
                                <div v-for="item in group.children" :key="item.id" class="cursor-pointer group relative w-full flex items-center justify-between gap-2 border border-[#EAECF0] hover:bg-[#F2F4F7] transition-all rounded-r-[10px] rounded-l-[10px] hover:!rounded-l-[5px] p-[15px]" :class="{ 'bg-[#F2F4F7]': $chatCustomizer.selectedSecondaryMenu == item.id }" @click="$chatCustomizer.changeSecondaryMenu(item.id)">
                                    <div class="absolute top-0 left-0 bg-[#1D2939] w-[3px] h-full rounded-l-[10px] transition-all" :class="{ 'hidden': !($chatCustomizer.selectedSecondaryMenu == item.id), 'group-hover:block': !($chatCustomizer.selectedSecondaryMenu == item.id) }">
                                    </div>
                                    <div class="flex items-end gap-2">
                                        <Icon :name="item.icon" size="24px" class="text-[#667085]" />
                                        <div class="text-[#101828] font-semibold text-base">{{ item.name }}</div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </Sidebar>
    </div>

    <!-- main content -->
    <main class="py-[32px] bg-[#F2F4F7] h-screen overflow-y-scroll prebook-chat-customizer" :style="{
        paddingLeft: (isLg || isXl) ? $chatCustomizer.sidebarWidth : '',
    }">
        <router-view v-slot="{ Component }">
            <component :is="Component"></component>
        </router-view>
    </main>
</div>
</template>


<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active in <2.1.8 */
    {
    opacity: 0;
}
</style>